namespace TabAurous.Sales {
    export interface RateFixingTaxRow {
        TransTaxId?: number;
        TransId?: number;
        HSN?: string;
        ProductTypeId?: number;
        NetAmount?: number;
        TaxId?: number;
        TaxRate?: number;
        TaxAmount?: number;
        Tax1Id?: number;
        Tax1Rate?: number;
        Tax1Amount?: number;
        Tax2Id?: number;
        Tax2Rate?: number;
        Tax2Amount?: number;
        CessId?: number;
        CessRate?: number;
        CessAmount?: number;
        Cess1Id?: number;
        Cess1Rate?: number;
        Cess1Amount?: number;
        Cess2Id?: number;
        Cess2Rate?: number;
        Cess2Amount?: number;
        TaxLedgerId?: number;
        Tax1LedgerId?: number;
        Tax2LedgerId?: number;
        CessLedgerId?: number;
        Cess1LedgerId?: number;
        Cess2LedgerId?: number;
    }

    export namespace RateFixingTaxRow {
        export const idProperty = 'TransTaxId';
        export const nameProperty = 'HSN';
        export const localTextPrefix = 'Sales.RateFixingTax';
        export const deletePermission = 'Sales:RateFixing:Delete';
        export const insertPermission = 'Sales:RateFixing:Add';
        export const readPermission = '*';
        export const updatePermission = 'Sales:RateFixing:Edit';

        export declare const enum Fields {
            TransTaxId = "TransTaxId",
            TransId = "TransId",
            HSN = "HSN",
            ProductTypeId = "ProductTypeId",
            NetAmount = "NetAmount",
            TaxId = "TaxId",
            TaxRate = "TaxRate",
            TaxAmount = "TaxAmount",
            Tax1Id = "Tax1Id",
            Tax1Rate = "Tax1Rate",
            Tax1Amount = "Tax1Amount",
            Tax2Id = "Tax2Id",
            Tax2Rate = "Tax2Rate",
            Tax2Amount = "Tax2Amount",
            CessId = "CessId",
            CessRate = "CessRate",
            CessAmount = "CessAmount",
            Cess1Id = "Cess1Id",
            Cess1Rate = "Cess1Rate",
            Cess1Amount = "Cess1Amount",
            Cess2Id = "Cess2Id",
            Cess2Rate = "Cess2Rate",
            Cess2Amount = "Cess2Amount",
            TaxLedgerId = "TaxLedgerId",
            Tax1LedgerId = "Tax1LedgerId",
            Tax2LedgerId = "Tax2LedgerId",
            CessLedgerId = "CessLedgerId",
            Cess1LedgerId = "Cess1LedgerId",
            Cess2LedgerId = "Cess2LedgerId"
        }
    }
}
